import React, {useEffect, useState} from "react";
import _ from "lodash";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {AD_SET_INPUT_FIELDS, DEFAULT_AD_SET} from "../../constants/ad-set.constant";
import {addSingleAdSet, saveSingleAdSet, updateSingleAdSet} from "../../services/facebook-ad-set-data.service";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import {createAdSet, createCampaign} from "../../services/facebook-ads-service";
import {saveSingleCampaign} from "../../services/facebook-campaign-data.service";

const AddEditAdSet = ({
                          selectedAdSet = {},
                          refreshAdSetList = undefined,
                          isAddAdSet = false,
                          isEditAdSet = false,
                          designDetail = undefined,
                          facebookTargetingInterest = undefined,
                          campaign = undefined,
                      }) => {
    const [showModal, setShowModal] = useState(false);
    const [adSet, setAdSet] = useState(selectedAdSet as any);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [adSetFieldInputs, setAdSetFieldInputs] = useState(AD_SET_INPUT_FIELDS);

    useEffect(() => {

        if (showModal) {
            if (isEditAdSet) {
                setAdSet(selectedAdSet);
            } else {
                prepareNewAdSet();
            }
        }

    }, [showModal]);

    const prepareNewAdSet = () => {
        if (designDetail) {
            const newAdSet: any = DEFAULT_AD_SET;
            newAdSet.campaign_id = campaign.id;
            newAdSet.name = designDetail.name;
            newAdSet.designId = designDetail?.id;

            let today = new Date();
            newAdSet.start_time = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

            const interests = _.filter(_.values(facebookTargetingInterest?.interests), (interest) => {
                return interest.isRelevant;
            });

            newAdSet.targeting.interests = _.map(interests, (interest) => {
                return {id: interest.id, name: interest.name};
            });

            setAdSet(newAdSet);
        } else {
            setAdSet({});
        }
    }

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingAdSet = {...adSet};

        if (existingAdSet && !existingAdSet?.adSetId) {
            const createdAdSet: any = await createAdSet(existingAdSet);
            existingAdSet.adSetId = createdAdSet?.id;
            existingAdSet.id = createdAdSet?.id;
        }

        await saveSingleAdSet(existingAdSet);

        setSaveInProgress(false);
        setShowModal(false);

        if (refreshAdSetList) {
            refreshAdSetList();
        }
    }

    const handleAdSetChanges = (event) => {
        let existingAdSet = {...adSet};
        existingAdSet = handleFieldValueChanges(event, existingAdSet);
        setAdSet(existingAdSet);

        console.log('existingAdSet', existingAdSet);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            {isAddAdSet &&
                <button
                    className="button-green px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Add Ad Set
                </button>
            }

            {isEditAdSet &&
                <button
                    className="button-green-outline px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddAdSet &&
                                            <>Add Ad Set</>
                                        }

                                        {isEditAdSet &&
                                            <>Edit Ad Set</>
                                        }
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        {/*<div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={adSet}
                                                handleDetailChanges={handleAdSetChanges}
                                                fieldList={_.groupBy(adSetFieldInputs, 'group')['adSet']}
                                                enableEdit={true}/>
                                        </div>*/}

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={adSet}
                                                handleDetailChanges={handleAdSetChanges}
                                                fieldList={_.groupBy(adSetFieldInputs, 'group')['detail']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>

                                        {/*<div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={adSet}
                                                handleDetailChanges={handleAdSetChanges}
                                                fieldList={_.groupBy(adSetFieldInputs, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>*/}

                                        <div className="flex flex-wrap justify-start mt-4">
                                            {adSet?.targeting?.interests?.map((interest, index) => (
                                                <div key={index}
                                                     className={'px-2 py-0 text-sm border border-purple-500 text-purple-500 bg-purple-100 m-1 rounded-lg'}>{interest?.name}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Ad Set
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditAdSet
